export default __webpack_public_path__ + "static/media/fish-enabled.0221930a.webp";